var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0ab974a7b54476449935eeed6f9f2dd5da72707f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs@axelthiele"]={id:"0ab974a7b54476449935eeed6f9f2dd5da72707f"};
      